// Assembly: AngularLocalization
(function(window, document, undefined) {

  /*
   * Included File: AngularLocalization.js
   */
  var app = angular.module("AngularLocalization" , []);

  app.factory("AngularLocalization", ["$rootScope", function($rootScope) {
    //first argument is the lang object that contains the localized values for each string
    //second argument is a lookup key for the lang object
    //third argument is an array of replacement variables that will be mapped onto the retrieved localized string, replacing %{0}, %{1}, etc..
    var i18n = function(lang, key, replacements) {
          var localizedString;

          if ( typeof key == 'undefined') {
            throw new Error('i18n expects a key');
          }

          try {
            localizedString = lang[key];
          } catch(ex) {
            throw new Error('i18n could not find key \'' + key + '\'');
          }

          if (_.isArray(replacements) && replacements.length > 0 && localizedString) {
            for (var i = 0, iLen = replacements.length; i < iLen; i++) {
              var replacementString = replacements[i];
              var placeholderPattern = new RegExp('%\\{' + i + '\\}', 'ig');
              if(replacementString){
                localizedString = localizedString.replace(placeholderPattern, replacementString);
              }
            }
          }

          return localizedString;
    };
    return {i18n : i18n};
  }]);

})(window, document);
